module.exports = __webpack_public_path__ + "img/EU.709af398.jpg";